module.exports = __webpack_public_path__ + "img/T718.2a21d041.jpg";